import { Component, HostListener, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthorizationService } from 'src/app/services';
import { LookerAdminService } from 'src/app/services/looker-admin.service';

@Component({
  selector: 'app-rx-audit-summary',
  templateUrl: './rx-audit-summary.component.html',
  styleUrls: ['./rx-audit-summary.component.css']
})
export class RxAuditSummaryComponent implements OnInit {

  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private route: ActivatedRoute,
    private lookerAdminService: LookerAdminService
  ) {}

  public serviceName:string = 'RxAudit';
  public feature: string = 'UI::MenuItemMetrics'
  public loadingStatus: boolean;
  public pageSize = 10;
  private routeSub: any;
  routeActivated = false;
  healthcareTopBarLoaded: Subscription;
  scroll: any;

  ngAfterViewInit(): void {
    const self = this;
    if (this.authorizationService.topBarLoaded === true) {
      if (!this.authorizationService.hasFeature(this.feature)) {
        this.router.navigate(['/']);
      }
    } else {
      this.healthcareTopBarLoaded =
        this.authorizationService.healthcareLoadedSubject$.subscribe(() => {
          if (!this.authorizationService.hasFeature(this.feature)) {
            this.router.navigate(['/']);
          }
          self.healthcareTopBarLoaded.unsubscribe();
        });
    }
  }

  ngOnInit(): void {
    this.scroll = window.pageYOffset;
    const self = this;
  }
  // clean up to prevent memory leaks, by unsubscribing to subscribed events
  ngOnDestroy(): void {}
  // check if user has edit feature
  initialPageSetup(): void {}

  routeChanged(): void {
    this.routeActivated = true;
    if (this.authorizationService.HealthcareTopBar) {
      this.authorizationService.HealthcareTopBar.notifyActivity();
    }
  }

  sideNavDashboardItemsComplete($event) {
    this.lookerAdminService.sendMessage($event);
  }
}
